<input type="checkbox" [checked]="checked" [name]="inputName" [id]="inputName" (change)="update()" />
<label [for]="inputName" class="ms-auto">Toggle</label>
